import { gql } from 'graphql-request'

export const EXPORT_USER_MANAGEMENT = gql`
  query ExportUserManagement {
    exportUserManagement
  }
`
